import react, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import Table from "../../../Layout/Table/Table";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BillingRequests from "../BillingRequests";
import { Puff } from "react-loading-icons";
import BillingNavigation from "../BillingNavigation";
import NavBar from "../../../../components/NavBar";

const BillingInvoices = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const ActionColumn = ({ link }) => {
    return (
      <div>
        <a className="btn btn-primary" target="_blank" href={link} rel="noreferrer">
          <i className="fa-solid fa-download me-3"></i>Descarregar
        </a>
      </div>
    );
  };

  const columns = ["Data", "Fatura", "Nº Movimento", "Valor", "IVA", "PDF"];

  const serializeRowsColums = () => {
    return data.map((item) => {
      // let obj = item;
      // obj["status"] = <StatusColumn status={obj.status} />;
      // obj["Actions"] = <ActionColumn id={obj.id} />;
      return {
        ...item,
        PDF: <ActionColumn link={item.link} />,
      };
    });
  };

  const handlerRequestList = async () => {
    setIsLoading(true);
    let info = await BillingRequests.getInvoiceList(params);
    if (info && info.status) {
      setData(info.data.list);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    document.title = "Invoices | Nightspot Dashboard";
    handlerRequestList();
  }, []);

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-8">
                    <h2 className="dashboard-h2">Lista de Faturas</h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <nav>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/my/dashboard">
                            <i className="fa-solid fa-home"></i>
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/my/nightspots">Lista Nightspots</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to={`/my/billing/manager/${params.id_venues}`}>
                            Gestão de subscrição
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Lista de Faturas
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12">
                    <div className="row mt-3">
                      <div className="col-5 col-sm-3 ">
                        <BillingNavigation tab="invoices" />
                      </div>
                      <div className="col-7 col-sm-9 container">
                        <div className="row">
                          <div className="col-12 event-list-table">
                            <Table
                              columns={columns}
                              data={serializeRowsColums(data)}
                              currentPage={1}
                              itemsPerPage={10}
                              totalItems={data.length}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
      {/* <ToastContainer /> */}
    </div>
  );
};

export default BillingInvoices;
